import request from 'superagent';

class CoinStore {
  static isAvailable(coin) {
    for (let i = 0, l = coin.providers.length; i < l; i += 1) {
      const provider = coin.providers[i];
      if (provider.available === true) return true;
    }
    return false;
  }

  static searchCoins(prefix, callback) {
    request
      .get(`${process.env.REACT_APP_API_URL}/public/coins`)
      .query({
        prefix,
      })
      .accept('json')
      .end((error, response) => {
        if (error) return callback(error.message);
        if (response.body.status === 'fail' && response.body.code === 'NOT_FOUND') return callback(false, []);
        if (response.body.status !== 'success') return callback(response.body.message);

        return callback(false, response.body.data.coins);
      });
  }

  constructor() {
    this.getCoins = this.getCoins.bind(this);
    this.addListener = this.addListener.bind(this);
    this.removeListener = this.removeListener.bind(this);
    this.fireChanged = this.fireChanged.bind(this);
    this.getBySymbol = this.getBySymbol.bind(this);
    this.onChangeFunctions = [];

    this.loaded = false;
    this.total = 0;
    this.coins = [];
  }

  addListener(func) {
    this.onChangeFunctions.push(func);
  }

  removeListener(func) {
    for (let i = 0, l = this.onChangeFunctions.length; i < l; i += 1) {
      if (this.onChangeFunctions[i] === func) {
        this.onChangeFunctions.splice(i, 1);
        break;
      }
    }
  }

  fireChanged() {
    this.onChangeFunctions.forEach((func) => {
      func();
    });
  }

  getBySymbol(symbol, callback) {
    for (let i = 0, l = this.coins.length; i < l; i += 1) {
      if (this.coins[i].symbol === symbol) return callback(false, this.coins[i]);
    }

    return request
      .get(`${process.env.REACT_APP_API_URL}/public/coin/${symbol}`)
      .accept('json')
      .end((error, response) => {
        if (error && response.body.code === 'NOT_FOUND') return callback(`Coin with the symbol '${symbol}' could not be found.`);
        if (error) return callback(error.message);
        if (response.body.status !== 'success') return callback(response.body.message);

        return callback(false, response.body.data.coin);
      });
  }

  getCoins(options, callback) {
    let limit = 30;
    if (options.limit) ({ limit } = options);

    let offset = 0;
    if (options.offset) ({ offset } = options);

    // als de options hetzelfde zijn als de geladen coins; dan geen coins erbij laden
    if (limit + offset === this.coins.length) return callback(false, this.coins);

    return request
      .get(`${process.env.REACT_APP_API_URL}/public/coins`)
      .query({
        limit,
        offset,
      })
      .accept('json')
      .end((error, response) => {
        if (error) return callback(error.message);
        if (response.body.status === 'fail' && response.body.code === 'NOT_FOUND') {
          this.loaded = true;
          this.fireChanged();

          return callback(false, []);
        }
        if (response.body.status !== 'success') return callback(response.body.message);

        if (offset === 0) {
          this.coins = response.body.data.coins;
        } else {
          this.coins = this.coins.concat(response.body.data.coins);
        }

        this.total = response.body.data.total;
        this.loaded = true;
        this.fireChanged();

        return callback(false, this.coins);
      });
  }
}

export default CoinStore;



// WEBPACK FOOTER //
// ./src/stores/Coin.js